
export enum widgetType {
    Barchart = 0,
    Linechart = 1,
    Areachart = 2,
    Label = 3,
    Table = 4
}

export enum messageType {
    Info = "Info",
    Warning = "Warning",
    Error = "Error",
}

export enum dataSourceType {
    WFM = 0,
    Realtime = 1,
    Ticketing = 2,
    CustomerInteraction = 3
}

export enum widgetComponentType {
   Queues = 0,
   Agents = 1,
   Calls = 2,
   Reports = 3,
   RuleMatch = 4
}

export enum colorScheme {
    Default = 0,
    Ash = 1,
    Grey = 2,
    Dark = 3,
    Ruby = 4,
    Blue = 5,
    Mustard = 6,
    Green = 7,
    Lilac = 8
}

export enum tableColorScheme {
    Default = 0,
    Ash = 1,
    Grey = 2,
    Dark = 3,
    Ruby = 4,
    Blue = 5,
    Mustard = 6,
    Green = 7,
    Lilac = 8,
    Turquoise = 9,
    Red = 10
}

export enum labelColorScheme {
    Default = 0,
    Ash = 1,
    Grey = 2,
    Dark = 3,
    Ruby = 4,
    Blue = 5,
    Mustard = 6,
    Green = 7,
    Lilac = 8
}

export enum traffic {
    offered = 0,
    answered = 1
}

export enum AppEventType {
    DashboardsCancelEvent = 'DASHBOARDS_CANCEL_EVENT',
  }

export enum widgetAppearanceType {
    LeggendTitle = 0,
    LeggendElements = 1,
    XAxisTitle = 2,
    XAxisLables = 3,
    YAxisTitle = 4,
    YAxisLables = 5,
    Titles = 6,
    Values = 7
}

export enum gridItemType {
  column,
  line,
  area
}

export type GroupingValue = "M" | "D" | "H" | "Q" | "W";
export type Months = "01" | "02" | "03" | "04" | "05" | "06" | "07" | "08" | "09" | "10" | "11" | "12";
